<script setup lang="ts">
interface Props {
  name: string
  fieldTooltip?: StoryBlokTooltip
  label?: string
  min?: number | string
  max?: number | string
  step?: number
  range?: Record<string, number | number[]>
  sliderType?: any[]
}
const originalProps = defineProps<Props>()
const props = useStoryblokProps(originalProps)
const type = props.sliderType?.[0].component
</script>

<template>
  <LazyFormFieldSliderAmountSimple v-if="type === 'sliderAmountSimple'" v-bind="props" />
  <LazyFormFieldSliderRangeWithInput v-if="type === 'sliderRangeWithInput'" v-bind="props" />
  <LazyFormFieldSliderAmountWithInput v-if="type === 'sliderAmountWithInput'" v-bind="props" />
</template>
